/* eslint-disable no-param-reassign */
// creates a map based on the column config for dugout-common tables
export default (columns) => {
    return columns.reduce((result, column) => {
      const key = column.id || column.accessor;
      const columnOperation = column.operation || '';
      let columnType;
  
      if (column.Filter) {
        columnType = 'Dropdown';
      } else if (column.filterable === true) {
        columnType = 'Search';
      } else if (column.isDate === true) {
        columnType = 'Date';
      } else {
        columnType = '';
      }
  
      result[key] = { columnType, columnOperation };
  
      return result;
    }, {});
  }


// WEBPACK FOOTER //
// ./src/features/agent-coaching/generateTableColumnsMap.js